module.exports = __webpack_public_path__ + "img/icon_search_black.6b385f49.svg";